export default __webpack_public_path__ + "static/media/delivery.c4d70c76.png";